



































































































import {Vue, Component, Watch} from 'vue-property-decorator';
import {Grid} from '@toast-ui/vue-grid';
import TuiGrid from 'tui-grid';
import {formatCurrency} from '@/utils/formatUtils';
import {ProductsConfigurableOption} from 'supporter';
@Component({
  components: {}
})
export default class SetProduct extends Vue {
  private formatCurrency = formatCurrency;
  private index = 0;
  private mallNo = 0;
  private deliveryTemplateNo = 0;
  private products: ProductsConfigurableOption[] = [];
  private applyProducts: ProductsConfigurableOption[] = [];
  private wmsUsed = false;
  private callback: any = null;
  private condition = {
    mallProductNo: '',
    productName: '',
    productManagementCd: '',
    mallOptionNo: '',
    optionManagementCd: ''
  };
  created() {
    this.index = Number(this.$route.query.index);
    this.mallNo = Number(this.$route.query.mallNo);
    this.deliveryTemplateNo = Number(this.$route.query.deliveryTemplateNo);
    if (this.$route.query.hasOwnProperty('dataCallback')) {
      this.callback = this.$route.query.dataCallback as string;
    }
    this.initGrid();
    this.search(1).then(() => {
      if (this.$route.query.hasOwnProperty('data')) {
        const data = JSON.parse(this.$route.query.data as string);
        data.forEach((product) => {
          const finded = this.products.find((prodcut) => prodcut.mallProductNo === product.mallProductNo && prodcut.mallOptionNo === product.mallOptionNo);
          if (finded) {
            this.applyProducts.push(finded);
          }
        });
        const grid = this.$refs.selectedOptionListGrid as Grid;
        grid.invoke('resetData', this.applyProducts as any);
      }
    });
    TuiGrid.setLanguage('ko', {
      display: {
        noData: window.$t('PRODUCT_OPTION_NO_DATA')
      }
    });
  }
  mounted() {
    const optionListGrid = this.$refs.optionListGrid as Grid;
    const selectedOptionListGrid = this.$refs.selectedOptionListGrid as Grid;
    if (this.products.length === 0) {
      this.$nextTick().then(() => {
        optionListGrid.invoke('disable');
      });
    }
    if (this.applyProducts.length === 0) {
      this.$nextTick().then(() => {
        selectedOptionListGrid.invoke('disable');
      });
    }
    
    const pagination = optionListGrid.invoke('getPagination');
    if (pagination) {
      optionListGrid.invoke('on', 'beforePageMove', (ev: any) => {
        this.search(ev.page);
        ev.stop();
      });
    }
  }
  @Watch('applyProducts.length')
  onApplyProductsChanged() {
    const grid = this.$refs.selectedOptionListGrid as Grid;
    if (this.applyProducts.length === 0) {
      grid.invoke('disable');
    } else {
      grid.invoke('enable');
    }
  }
  @Watch('products.length')
  onProductsChanged() {
    const grid = this.$refs.optionListGrid as Grid;
    if (this.products.length === 0) {
      grid.invoke('disable');
    } else {
      grid.invoke('enable');
    }
  }
  initGrid() {
    let GRID_COLUMNS;
    if (this.wmsUsed) {
      GRID_COLUMNS = [
        this.girdColumns.itemMallProductNo,
        this.girdColumns.productManagementCd,
        this.girdColumns.productName,
        this.girdColumns.itemMallOptionNo,
        this.girdColumns.optionManagementCd,
        this.girdColumns.extraManagementCd,
        this.girdColumns.optionNameValuePair,
        this.girdColumns.originalMappingOptionSalePrice,
        this.girdColumns.itemSaleStockCnt,
        this.girdColumns.itemSafetyStockCnt,
        this.girdColumns.itemDeliveryWaitingStockCnt,
        this.girdColumns.optionSaleStatusType,
        this.girdColumns.optionSaleSettingStatusType
      ];
    } else {
      GRID_COLUMNS = [
        this.girdColumns.itemMallProductNo,
        this.girdColumns.productManagementCd,
        this.girdColumns.productName,
        this.girdColumns.itemMallOptionNo,
        this.girdColumns.optionManagementCd,
        this.girdColumns.extraManagementCd,
        this.girdColumns.optionNameValuePair,
        this.girdColumns.originalMappingOptionSalePrice,
        this.girdColumns.itemStockCnt,
        this.girdColumns.optionSaleStatusType,
        this.girdColumns.optionSaleSettingStatusType
      ];
    }
    this.setOptionListGrid(GRID_COLUMNS);
    this.setSelectedOptionListGrid(GRID_COLUMNS);
  }
  reset() {
    this.condition = {
      mallProductNo: '',
      productName: '',
      productManagementCd: '',
      mallOptionNo: '',
      optionManagementCd: ''
    };
  }
  async search(page: number) {
    this.options.pageOptions.page = page
    const params: any = {
      mallNo: this.mallNo,
      deliveryTemplateNo: this.deliveryTemplateNo,
      page,
      size: Number(this.options.pageOptions.perPage)
    };
    if (this.condition.mallProductNo) params.mallProductNo = this.condition.mallProductNo;
    if (this.condition.productName) params.productName = this.condition.productName;
    if (this.condition.productManagementCd) params.productManagementCd = this.condition.productManagementCd;
    if (this.condition.mallOptionNo) params.mallOptionNo = this.condition.mallOptionNo;
    if (this.condition.optionManagementCd) params.optionManagementCd = this.condition.optionManagementCd;
    await this.$api.getProductsConfigurableOptions({params}).then((res) => {
      this.products = res.data.contents;
      this.options.pageOptions.totalCount = res.data.totalCount;
      const grid = this.$refs.optionListGrid as Grid;
      const pagination = grid.invoke('getPagination') as any;
      if (pagination) {
        const pageState = {
          totalCount: this.options.pageOptions.totalCount,
          page: this.options.pageOptions.page,
          perPage: Number(this.options.pageOptions.perPage)
        };
        grid.invoke('resetData', this.products as any, {pageState});
      } else {
        grid.invoke('resetData', this.products as any);
      }
    });
  }
  setOptionListGrid(gridColumns: any) {
    this.productGridColumns = gridColumns;
  }
  setSelectedOptionListGrid(gridColumns: any) {
    this.applyProductGridColumns = gridColumns;
  }
  deleteApplyProducts() {
    const checkedRows = (this.$refs.selectedOptionListGrid as any).invoke('getCheckedRows');
    if (checkedRows.length) {
      const newApplyProducts: any[] = [];
      this.applyProducts.forEach((item) => {
        const finded = checkedRows.find((value: any) => item.mallOptionNo === value.mallOptionNo);
        if (!finded) {
          newApplyProducts.push(item);
        }
      });
      this.applyProducts = newApplyProducts;
      (this.$refs.selectedOptionListGrid as Grid).invoke('resetData', this.applyProducts as any);
    } else {
      alert(window.$t('PRODUCT_OPTION_PLEASE_SELECT'));
    }
  }
  addSelectedOption() {
    const checkedRows = (this.$refs.optionListGrid as any).invoke('getCheckedRows');
    if (checkedRows.length === 0) {
      alert(window.$t('PRODUCT_OPTION_PLEASE_ADD'));
      return;
    }
    const backupApplyProduct = [...this.applyProducts];
    let includeCount = 0;
    checkedRows.forEach((value: any) => {
      const findIndex = this.applyProducts.findIndex((item) => item.mallOptionNo === value.mallOptionNo);
      if (findIndex < 0) {
        value._attributes.checked = false;
        this.applyProducts.push(value);
      } else {
        includeCount++;
      }
    });
     if (this.applyProducts.length > 10) {
      alert(window.$t('PRODUCT_OPTION_PLEASE_MAX_10_SET'));
      this.applyProducts = [...backupApplyProduct];
      return;
    }
    (this.$refs.selectedOptionListGrid as Grid).invoke('resetData', this.applyProducts as any);
    if (includeCount) {
      if (checkedRows.length === includeCount) {
        alert(window.$t('PRODUCT_OPTION_ALREADY_ADD'));
      } else {
        alert(window.$t('PRODUCT_OPTION_ALREADY_ADD_SUCCESS'));
      }
    }
  }
  save() {
    $(window.opener.location).attr('href', `javascript:window.${this.callback}(${JSON.stringify(this.applyProducts)},${JSON.stringify(this.index)});`);
    this.close();
  }
  close() {
    window.close();
  }
  private options = {
    columnOptions: {
      minWidth: 70
    },
    rowHeaders: ['checkbox'],
    bodyHeight: 150,
    rowHeight: 31,
    virtualScrolling: true,
    minRowHeight: 31,
    displayRowCount: 10,
    isInitialRequest: false,
    useClientSort: false,
    heightResizable: true,
    pageOptions: {
      visiblePages: 10,
      perPage: 15,
      page: 1,
      totalCount: 0
    }
  };
  private selectedProductsOptions = {
    columnOptions: {
      minWidth: 70
    },
    rowHeaders: ['checkbox'],
    bodyHeight: 150,
    rowHeight: 31,
    virtualScrolling: true,
    minRowHeight: 31,
    displayRowCount: 10,
    isInitialRequest: false,
    useClientSort: false,
    heightResizable: true,
    pageOptions: {
      visiblePages: 1,
      perPage: 10,
      page: 1,
      totalCount: 0
    }
  };
  private productGridColumns = [];
  private applyProductGridColumns = [];
  private girdColumns = {
    itemMallProductNo: {
      header: window.$t('PRODUCT_OPTION_PRODUCT_NUM'),
      name: 'mallProductNo',
      align: 'center',
      width: 90
    },
    productManagementCd: {
      header: window.$t('PRODUCT_OPTION_PRODUCT_MANAGE_CODE'),
      name: 'productManagementCd',
      align: 'center',
      width: 100
    },
    productName: {
      header: window.$t('PRODUCT_OPTION_PRODUCT_NAME'),
      name: 'productName',
      align: 'left',
      minWidth: 120
    },
    itemMallOptionNo: {
      header: window.$t('PRODUCT_OPTION_OPTION_NUM'),
      name: 'mallOptionNo',
      align: 'center',
      width: 90
    },
    optionManagementCd: {
      header: window.$t('PRODUCT_OPTION_OPTION_MANAGE'),
      name: 'optionManagementCd',
      align: 'center',
      width: 100
    },
    extraManagementCd: {
      header: window.$t('PRODUCT_OPTION_EXTRA_MANAGEMENT_CODE'),
      name: 'extraManagementCd',
      align: 'center',
      width: 100
    },
    optionNameValuePair: {
      header: window.$t('PRODUCT_OPTION_OPTION_NAME_PRICE'),
      name: 'combinedOptionNameValue',
      align: 'center',
      width: 140
    },
    originalMappingOptionSalePrice: {
      header: window.$t('PRODUCT_OPTION_SALE_PRICE'),
      name: 'optionSalePrice',
      width: 60,
      align: 'center',
      formatter: ({value}: any) => {
        return this.formatCurrency(value);
      }
    },
    itemStockCnt: {
      header: window.$t('PRODUCT_OPTION_STOCK'),
      name: 'stockCnt',
      width: 50,
      align: 'center'
    },
    itemSaleStockCnt: {
      header: window.$t('PRODUCT_OPTION_SALE_ABLE_STOCK'),
      name: 'itemStockCnt',
      width: 50,
      align: 'center'
    },
    itemSafetyStockCnt: {
      header: window.$t('PRODUCT_OPTION_SAGE_STOCK'),
      name: 'itemSafetyStockCnt',
      width: 50,
      align: 'center'
    },
    itemDeliveryWaitingStockCnt: {
      header: window.$t('PRODUCT_OPTION_RELEASE_STANDBY'),
      name: 'itemDeliveryWaitingStockCnt',
      width: 50,
      align: 'center'
    },
    optionSaleStatusType: {
      header: window.$t('PRODUCT_OPTION_SALE_STATUS'),
      name: 'saleStatusType',
      width: 80,
      align: 'center',
      formatter: ({value, row}: any) => {
        if (row.saleSettingStatusType === 'PROHIBITION_SALE') {
          return '-';
        }

        if (value === 'PRE_APPROVAL_STATUS') {
          return window.$t('PRODUCT_OPTION_BEFORE_ADMIT');
        } else if (value === 'ON_PRE_SALE') {
          return window.$t('PRODUCT_OPTION_PRE_SELLING');
        } else if (value === 'WAITING_SALE') {
          return window.$t('PRODUCT_OPTION_SALE_WAIT');
        } else if (value === 'ON_SALE') {
          return window.$t('PRODUCT_OPTION_SELLING');
        } else if (value === 'END_SALE') {
          return window.$t('PRODUCT_OPTION_SELL_STOP');
        }
        return value;
      }
    },
    optionSaleSettingStatusType: {
      header: window.$t('PRODUCT_OPTION_SALE_SETTING_STATUS'),
      name: 'saleSettingStatusType',
      width: 80,
      align: 'center',
      formatter: ({value, row}: any) => {
        if (row.saleStatusType === 'END_SALE') {
          return '-';
        }

        if (value === 'AVAILABLE_FOR_SALE') {
          return window.$t('PRODUCT_OPTION_AVAILABLE_FOR_SALE');
        } else if (value === 'WAITING_PRE_SALE') {
          return window.$t('PRODUCT_OPTION_WAITING_PRE_SALE');
        } else if (value === 'PROHIBITION_SALE') {
          return window.$t('PRODUCT_OPTION_PROHIBITION_SALE');
        }
        return value;
      }
    }
  };
  beforeDestory() {
    TuiGrid.setLanguage('ko', {
      display: {
        noData: window.$t('PRODUCT_OPTION_SEARCH_NO_DATA')
      }
    });
  }
  private beforeApprovalStatus = ['APPROVAL_READY', 'APPROVAL_REJECTION', 'SALE_AGREEMENT_READY', 'SALE_AGREEMENT_REJECTION'];
}
